import {Injectable} from "@angular/core";
import {BaseSystemConfigurationValues} from "./base.system.configuration.manager";

/**
 Service class for getting system configuration from server after validity checks.
 */

@Injectable({
  providedIn: 'root'
})
export class SystemConfigurationValues extends BaseSystemConfigurationValues {
  public get SelfSchedulingUserIdleTimeout() {
      return this.getNumber('PP_SelfSchedulingUserIdleTimeout');
  }

  public get TimeslotReservationEnabled() {
    return this.getBoolean('TimeslotReservationEnabled');
  }

  public get PP_ContactInfoMask() {
    return this.getValidatedString('PP_ContactInfoMask');
  }

  public get PP_MainContactTelephone() {
    return this.getValidatedString('PP_MainContactTelephone');
  }

  public get WeekendIntValues() {
    return this.getValidatedString('WeekendIntValues');
  }

  public get PP_ShowWeekNumbersInCalendar() {
    return this.getBoolean('PP_ShowWeekNumbersInCalendar');
  }

  public get PP_CalendarFirstDayOfWeek() {
    return this.getNumber('PP_CalendarFirstDayOfWeek');
  }

  public get PP_MorningTimeRange() {
    return this.getValidatedString('PP_MorningTimeRange');
  }

  public get PP_AfternoonTimeRange() {
    return this.getValidatedString('PP_AfternoonTimeRange');
  }

  public get PP_EveningTimeRange() {
    return this.getValidatedString('PP_EveningTimeRange');
  }

  public get PP_ShowNewScheduleButton() {
    return this.getBoolean('PP_ShowNewScheduleButton');
  }

  public get CanCancelOpCodeKey() {
    return this.getNumber('CanCancelOpCodeKey');
  }

  public get CanRescheduleOpCodeKey() {
    return this.getNumber('CanRescheduleOpCodeKey');
  }

  public get CanScheduleOpCodeKey() {
    return this.getNumber('CanScheduleOpCodeKey');
  }

  public get LockDurationInMinutes() {
    return this.getNumber('LockDurationInMinutes');
  }

  public get CanNewOrderAndScheduleOpCodeKey() {
    return this.getNumber('CanNewOrderAndScheduleOpCodeKey');
  }

  public get UserPasswordPattern() {
    return this.getNumber('PP_UserPasswordPattern');
  }

  public get UserPasswordLength() {
    return this.getNumber('PP_UserPasswordLength');
  }

  public get PP_AdditionalInformationAvailable() {
    return this.getBoolean('PP_AdditionalInformationAvailable');
  }

  public get PP_EnableFormStepInScheduleOrder() {
    return this.getValidatedString('PP_EnableFormStepInScheduleOrder');
  }

  public get PP_ScheduleOrderForm() {
    return this.getValidatedString('PP_ScheduleOrderForm');
  }

  public get PP_FormEditForm() {
    return this.getValidatedString('PP_FormEditForm');
  }

  public get CanEditFormOpCodeKey() {
    return this.getNumber('CanEditFormOpCodeKey');
  }

  public get PP_EditFormScreenContents() {
    return this.getValidatedString('PP_EditFormScreenContents');
  }

  public get PasswordExpirationWarning() {
    return this.getNumber('PP_PasswordExpirationWarning');
  }

  public get PP_ScanDocumentMaxSizeKB() {
    return this.getNumber('PP_ScanDocumentMaxSizeKB');
  }

  public get PP_ScanDocumentMaxPixelSizeLongEdge() {
    return this.getNumber('PP_ScanDocumentMaxPixelSizeLongEdge');
  }

  public get PP_ScanDocumentImageQualityPercentage() {
    return this.getNumber('PP_ScanDocumentImageQualityPercentage');
  }

  public get PP_ScanDocumentAttachments() {
    return this.getValidatedString('PP_ScanDocumentAttachments');
  }

  public get PP_ScheduleGapWarningMinutes() {
    return this.getNumber('PP_ScheduleGapWarningMinutes', 30);
  }

  public get PP_MoreInfoForm() {
    return this.getValidatedString('PP_AdditionalInformationForm');
  }

  public get LockExpirationTimeInMinutes() {
    return this.getNumber('PP_LockExpirationTimeInMinutes');
  }

  public get ScannedOrderDocumentTypeKey() {
    return this.getNumber('ScannedOrderDocumentTypeKey');
  }
}
